package gr.tech.pdfgenerator.util

import kotlin.js.Date


//Function to generate the date in a String
//Formatted as follows: YEARMONTHDAY
fun getCurrentDateString(): String {
    val date = Date()
    val year = date.getFullYear().toString()
    val month = (date.getMonth() + 1).toString().padStart(2, '0')
    val day = date.getDate().toString().padStart(2, '0')
    return "$year$month$day"
}

fun formatDate(timestamp: String): String {
    //Cheap "format", simply removing everything from T
    return if (timestamp.isNotEmpty() && timestamp.isNotBlank()) {
        timestamp.substringBefore("T")
    } else {
        ""
    }
}

fun formatDateToTime(timestamp: String?): String? {
    if (!timestamp.isNullOrEmpty() && timestamp.isNotBlank()) {
        val timeString = timestamp.substringAfter("T")
        val stringParts = timeString.split(":")
        return "${stringParts[0]}:${stringParts[1]}"
    } else {
        return null
    }
}

fun formatDateAndTime(timestamp: String?): String? {
    if (!timestamp.isNullOrEmpty() && timestamp.isNotBlank()) {
        val timeString = timestamp.split("T")
        val date = timeString[0]
        val time = timeString[1]

        val dateParts = date.split("-")
        val timeParts = time.split(":")
        return "${dateParts[1]}/${dateParts[2]}/${dateParts[0].drop(2)} ${timeParts[0]}:${timeParts[1]}"
    } else {
        return null
    }
}

fun String.truncate(maxLength: Int): String {
    return if (this.length > maxLength) {
        this.substring(0, maxLength) + "..."
    } else {
        this
    }
}